import React from "react";
import { Col, Progress, Row } from "antd";
import Typography from "@dtci/spellbook/Typography";
import { useJobViewDealSearchDisplay } from "tap/utils/hooks/useJobViewDealSearchDisplay.js";
import "./styles.scss";

/**
 * Shared Job View modal header with optional deal-search progress indicator.
 * @param {Object} props
 * @param {Object|null|undefined} props.selectedJob - Currently selected job
 * @param {Array} [props.jobTasks] - Job tasks used to detect the search step
 * @param {Array} [props.pendingStatuses] - Job statuses considered in progress
 */
export function JobViewModalHeader({
  selectedJob,
  jobTasks = [],
  pendingStatuses = [],
}) {
  const progress = useJobViewDealSearchDisplay(
    selectedJob,
    jobTasks,
    pendingStatuses,
  );
  const isPending = pendingStatuses.includes(selectedJob?.jobStatus);

  return (
    <Row className="job-view-modal-header">
      <Col className="job-view-modal-header__title">
        <Typography variant="T40">Job View</Typography>
      </Col>
      {progress.visible && (
        <Col className="job-view-modal-header__progress">
          <Typography variant="T20" className="job-view-modal-header__label">
            Search Transactional Deals
          </Typography>
          <Progress
            percent={progress.percent}
            status={
              progress.isComplete
                ? "success"
                : isPending
                  ? "active"
                  : "normal"
            }
            showInfo
          />
          <Typography
            variant="T15"
            className="job-view-modal-header__counts"
          >
            {progress.progressCount} / {progress.targetCount} deals
          </Typography>
        </Col>
      )}
      <Col className="job-view-modal-header__spacer" aria-hidden="true" />
    </Row>
  );
}
